export default __webpack_public_path__ + "static/media/240.cd96aa4a.png";